import styled from 'styled-components';

import { Button } from '@xing-com/button';
import type { ButtonSizes } from '@xing-com/button';
import { mediaTopBarHidden, mediaTopBarVisible } from '@xing-com/layout-tokens';

type ButtonSmallWhenTopBarProps = {
  $size: ButtonSizes;
};

const pickMediaQuery = ({ $size }: ButtonSmallWhenTopBarProps): string => {
  return $size === 'small' ? mediaTopBarHidden : mediaTopBarVisible;
};

export const ButtonSmallWhenTopBar = styled(Button)<ButtonSmallWhenTopBarProps>`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${pickMediaQuery} {
    display: none;
  }
`;
